// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { TrainingSession as TrainingSessionImpl } from './training-session-impl.js';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TrainingSession = TrainingSessionImpl;
//# sourceMappingURL=training-session.js.map